import { render, staticRenderFns } from "./ExtraInfoSection.vue?vue&type=template&id=21a85b78&scoped=true&"
import script from "./ExtraInfoSection.vue?vue&type=script&lang=js&"
export * from "./ExtraInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./ExtraInfoSection.vue?vue&type=style&index=0&id=21a85b78&prod&lang=css&"
import style1 from "./ExtraInfoSection.vue?vue&type=style&index=1&id=21a85b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a85b78",
  null
  
)

export default component.exports